import SharedFilesDrawer from 'pages/mobile/Finance/shared/drawers/FilesDrawer';
import React from 'react';

import { useConfirmingOperationDetail } from '../context';

const FilesDrawer: React.FC = () => {
  const { requestId } = useConfirmingOperationDetail();
  return <SharedFilesDrawer requestId={requestId} requestType="confirming" />;
};

export default FilesDrawer;
